import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'ms-skeleton-top-sports',
    templateUrl: './skeleton-topsports.component.html',
})
export class SkeletonTopsportsComponent {
    @HostBinding('class') className = 'sk-top-events-container sk-p-12 sk-b-rad5';
}
